import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionNgList extends BaseModelAPI {

	static entity = 'workorderexecutionnglist'
	static entityName = 'workorderexecutionng';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
